<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-peibishujuku"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.dataBackup') }}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading"
             element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small"
                     label-width="150px" label-position="left">
                <div class="info-table" ref="timeListBox">
                    <template v-if="list && list.length > 0">
                        <div class="info-item" v-for="(item, index) in list" :key="index">
                            <span style="margin-right: 20px">{{item.date}}</span>
                            <span>{{item.info}}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="no-data">{{ $t('ems.Nobackupinformation') }}</div>
                    </template>
                </div>
                <div style="color: #c1c1c1; margin-top: 40px">
                    {{ $t('ems.Notice') }}<br/>
                    1.{{ $t('ems.DatabackupTip1') }}<br/>
                    2.{{ $t('ems.DatabackupTip2') }}<br/>
                    3.{{ $t('ems.DatabackupTip3') }}<br/>
                </div>
                <div class="subminBox">
                    <div :class="{btn: true,  btn_active: saveActive === true}" @click="save"><i
                            class="iconfont icon-reset"></i><span>{{ $t('ems.startBackup') }}</span></div>
                    <div :class="{btn: true,  btn_active: cancelActive === true}" @click="cancel"><i
                            class="iconfont icon-baocun"></i><span>{{ $t('ems.cancelBackup') }}</span></div>
                </div>
            </el-form>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {getDbBackupSatus, startBbBackup, cancelBbBackup, getDbBackup} from '@/api/spms';

    export default {
        name: "mainSys",
        data() {
            return {
                opacity: 0,
                loading: false,
                saveActive: false,
                cancelActive: false,
                list: [],
                timer: null,
                timer1: null,
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        created() {

        },
        mounted() {
            getDbBackupSatus().then(res => {
                if (res.data.data) {
                    this.saveActive = false;
                    this.cancelActive = true;
                    this.loadInfo();
                } else {
                    this.saveActive = true;
                    this.cancelActive = false;
                }
            })
            setTimeout(() => {
                this.opacity = 1;
            }, 200);
        },
        methods: {
            save() {
                if (this.saveActive === true) {
                    this.loading = true;
                    startBbBackup().then(() => {
                        this.loading = false;
                        this.saveActive = false;
                        this.cancelActive = true;
                        this.loadInfo();
                        this.loadStatus();
                    }).catch(() => {
                        this.loading = false;
                    });
                }

            },

            cancel() {
                if (this.cancelActive) {
                    this.loading = true;
                    cancelBbBackup().then(() => {
                        this.loading = false;
                        this.saveActive = false;
                        this.cancelActive = false;
                        this.loadInfo();
                        this.loadStatus1();
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            },

            loadInfo() {
                if (this.timer) clearInterval(this.timer);
                getDbBackup().then(res => {
                    this.list = res.data.data;
                    setTimeout(() => {
                        this.$refs["timeListBox"].scrollTop = this.$refs["timeListBox"].scrollHeight;
                    }, 100);
                });
                this.timer = setInterval(() => {
                    getDbBackup().then(res => {
                        this.list = res.data.data;
                    });
                    setTimeout(() => {
                        this.$refs["timeListBox"].scrollTop = this.$refs["timeListBox"].scrollHeight;
                    }, 100);
                }, 2000)
            },

            loadStatus() {
                if (this.timer1) clearInterval(this.timer1);
                getDbBackupSatus().then(res => {
                    if (res.data.data) {
                        this.saveActive = false;
                        this.cancelActive = true;
                        this.loadInfo();
                    } else {
                        this.saveActive = true;
                        this.cancelActive = false;
                        if (this.timer) clearInterval(this.timer);
                    }
                });
                this.timer1 = setInterval(() => {
                    getDbBackupSatus().then(res => {
                        if (res.data.data) {
                            this.saveActive = false;
                            this.cancelActive = true;
                            this.loadInfo();
                        } else {
                            this.saveActive = true;
                            this.cancelActive = false;
                            if (this.timer) clearInterval(this.timer);
                        }
                    });
                }, 2000)
            },

            loadStatus1() {
                if (this.timer1) clearInterval(this.timer1);
                getDbBackupSatus().then(res => {
                    if (res.data.data) {
                        this.saveActive = false;
                        this.cancelActive = false;
                        this.loadInfo();
                    } else {
                        this.saveActive = true;
                        this.cancelActive = false;
                        if (this.timer) clearInterval(this.timer);
                    }
                });
                this.timer1 = setInterval(() => {
                    getDbBackupSatus().then(res => {
                        if (res.data.data) {
                            this.saveActive = false;
                            this.cancelActive = false;
                            this.loadInfo();
                        } else {
                            this.saveActive = true;
                            this.cancelActive = false;
                            if (this.timer) clearInterval(this.timer);
                        }
                    });
                }, 2000)
            }
        },
        destroyed() {
            if (this.timer1) clearInterval(this.timer1);
            if (this.timer) clearInterval(this.timer);
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";

    .win {
        width: 100%;
        height: 100%;

        .header {
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;

            .navItem {
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;

                i {
                    font-size: 22px;
                    margin: 3px 20px 0;
                }

                .title {
                    letter-spacing: 3px;
                    font-size: 22px;
                }

                .desc {
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
        }

        .content {
            overflow: hidden;
            height: calc(100% - 52px);
            box-sizing: border-box;
            padding: 20px;

            .table_header {
                height: 100%;
                background-color: var(--nav);
                border: #595959 solid 1px;
                box-sizing: border-box;
                padding: 50px;
                color: var(--input_font);
                position: relative;

                .subminBox {
                    text-align: center;
                    position: absolute;
                    bottom: 90px;
                    left: 610px;
                }

                .info-table {
                    height: 600px;
                    background-color: var(--panel_bg);
                    overflow-y: auto;

                    .info-item {
                        height: 30px;
                        line-height: 30px;
                        padding-left: 40px;
                        color: $font_bright_blue_title;
                        margin: 5px 0;
                    }

                    .no-data {
                        margin-top: 280px;
                        text-align: center;
                        font-size: 20px;
                        color: var(--input_font);
                    }
                }
            }
        }

        .btn {
            cursor: not-allowed;
            width: 120px;
        }

        .btn_active {
            cursor: pointer;
        }
    }
</style>
<style lang="scss">
    .table_header {
        .el-form-item__label {
            color: var(--input_font) !important;
            font-size: 16px !important;
        }

        .avatar-uploader {
            .el-upload {
                border: 1px dashed rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
        }
    }
</style>